export default __webpack_public_path__ + "static/media/mariadb-logo.52900ae8.svg";